import { CHANNELS, ChannelId, channelOfCode } from './acquisitionFunnel';

/** Pure helpers for Headlines → Growth, kept apart from the component so they are unit-testable. */

export interface GrowthSourceRow {
  source: string;
  label: string;
  /** Channel set on the campaign code, if any; null = derive from source. */
  channel: string | null;
  started: number;
  startedPrev: number;
  onboarded: number;
  onboardedPrev: number;
}

interface ChannelRow {
  id: ChannelId | 'total';
  label: string;
  color: string;
  started: number;
  startedPrev: number;
  onboarded: number;
  onboardedPrev: number;
}

export const channelRows = (sources: GrowthSourceRow[]): ChannelRow[] => {
  const byId = new Map<ChannelId, ChannelRow>();
  for (const ch of CHANNELS) {
    byId.set(ch.id, {
      id: ch.id,
      label: ch.label,
      color: ch.color,
      started: 0,
      startedPrev: 0,
      onboarded: 0,
      onboardedPrev: 0,
    });
  }
  for (const s of sources) {
    const row = byId.get(channelOfCode(s.source, s.channel))!;
    row.started += s.started;
    row.startedPrev += s.startedPrev;
    row.onboarded += s.onboarded;
    row.onboardedPrev += s.onboardedPrev;
  }
  return Array.from(byId.values())
    .filter(
      (r) => r.started + r.startedPrev + r.onboarded + r.onboardedPrev > 0,
    )
    .sort((a, b) => b.onboarded - a.onboarded || b.started - a.started);
};

/** Rolling `window`-day sums of a zero-filled daily series. */
export const rollingSum = (
  daily: Array<{ day: string; onboarded: number }>,
  window: number,
): Array<{ day: string; value: number }> =>
  daily.slice(window - 1).map((d, i) => ({
    day: d.day,
    value: daily.slice(i, i + window).reduce((acc, x) => acc + x.onboarded, 0),
  }));
